import React from "react";
import "./homesection5.css";
import HomeSection5IMG from "../../../assets/homesection5.png";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const Homesection5 = () => {
  const { t } = useTranslation("global");
  const { lang } = useParams();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section
      className="home-section5-container"
      aria-label="Our services overview"
    >
      <div className="container">
        <article className="left">
          <section
            className="service-card developers"
            aria-labelledby="software-solutions-heading"
          >
            <div className="service-content">
              <span className="icon" aria-hidden="true">
                <FontAwesomeIcon
                  icon={faArrowUpRightFromSquare}
                  style={{ background: "rgba(0, 0, 0, 0)" }}
                />
              </span>
              <div className="text">
                <h2 id="software-solutions-heading">
                  {t("homesection5.heading")}
                </h2>
                <p className="service-card-text1">{t("homesection5.text")}</p>
                <Link
                  to={`/${lang}/SoftwareSolutions`}
                  onClick={scrollToTop}
                  aria-label="Learn more about our Software Solutions"
                >
                  <button className="service-button">
                    {t("homesection5.button")}
                  </button>
                </Link>
              </div>
            </div>
            <figure className="service-image">
              <img
                src={HomeSection5IMG}
                alt="Code Example"
                loading="lazy"
                width="400"
                height="300"
              />
            </figure>
          </section>
        </article>

        <article className="right">
          <section
            className="service-card marketers"
            aria-labelledby="creative-design-heading"
          >
            <div className="service-content">
              <span className="icon" aria-hidden="true">
                <FontAwesomeIcon
                  icon={faArrowUpRightFromSquare}
                  style={{ background: "rgba(0, 0, 0, 0)" }}
                />
              </span>
              <div className="text">
                <h2 id="creative-design-heading">
                  {t("homesection5.heading2")}
                </h2>
                <p className="service-card-text2">{t("homesection5.text2")}</p>
                <Link
                  to={`/${lang}/CreativeDesign`}
                  onClick={scrollToTop}
                  aria-label="Learn more about our Creative Design services"
                >
                  <button className="service-button">
                    {t("homesection5.button")}
                  </button>
                </Link>
              </div>
            </div>
          </section>

          <section
            className="service-card consultants"
            aria-labelledby="advertising-media-heading"
          >
            <div className="service-content">
              <span className="icon" aria-hidden="true">
                <FontAwesomeIcon
                  icon={faArrowUpRightFromSquare}
                  style={{ background: "rgba(0, 0, 0, 0)" }}
                />
              </span>
              <div className="text">
                <h2 id="advertising-media-heading">
                  {t("homesection5.heading3")}
                </h2>
                <p className="service-card-text2">{t("homesection3.text3")}</p>
                <Link
                  to={`/${lang}/AdvertisingAndMedia`}
                  onClick={scrollToTop}
                  aria-label="Learn more about our Advertising and Media services"
                >
                  <button className="service-button">
                    {t("homesection3.button")}
                  </button>
                </Link>
              </div>
            </div>
          </section>
        </article>
      </div>
    </section>
  );
};

export default Homesection5;
